import ModalConfirmDelete from './Modal/ConfirmDelete'
import ModalConfirmResetPassword from './Modal/ConfirmResetPassword'
import ModalExpired from './Modal/Expired'
import ModalMessage from './Modal/Message'
import ModalPasswordChanged from './Modal/PasswordChanged'
import ModalPatientCreated from './Modal/PatientCreated'
import ModalSpinner from './Modal/Spinner'
import ModalUserCreated from './Modal/UserCreated'

const Modals = () => {
  return (
    <>
      <ModalSpinner />
      <ModalExpired />
      <ModalPasswordChanged />
      <ModalUserCreated />
      <ModalPatientCreated />
      <ModalConfirmDelete />
      <ModalConfirmResetPassword />
      <ModalMessage />
    </>
  )
}

export default Modals
